module.exports = __webpack_public_path__ + "images/2cabbb618211f7c4194a022a805e036b.svg";